import React from 'react';

const WineriesPage = React.lazy(() => import('pages/wineries'));
const WineriesEditPage = React.lazy(() => import('pages/wineries/edit'));
const SubmitNewWineryPage = React.lazy(() => import('pages/wineries/edit'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <WineriesPage />
  },
  {
    path: 'edit/:wineryID',
    policies: policies,
    component: <WineriesEditPage />
  },
  {
    path: 'new',
    policies: policies,
    component: <SubmitNewWineryPage />
  }
];
